import { render, staticRenderFns } from "./ClinicLabReport.vue?vue&type=template&id=79753204&scoped=true"
import script from "./ClinicLabReport.vue?vue&type=script&lang=js"
export * from "./ClinicLabReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79753204",
  null
  
)

export default component.exports